import { Injectable } from '@angular/core';
import { Routes } from "@angular/router";
import { BaseService } from "../shared/services/base.service";
import { AppService } from "../shared/services/app.service";
import { CommonResolverService } from "./common-resolver.service";
// import { menuDef } from "../definition/menuDef";
// import { routeDef } from "../definition/routeDef";
@Injectable() 
export class ApplicationInitService {
 public _resourceObj:any={};
 public menuDef:any=[];
 public routeDef:any=[];
 public crudList:any=[];
 public defaultApplication:any=[];
 public _appUri:string;

  constructor(
    public baseService: BaseService,
    public appService: AppService,
    public commonResolverService: CommonResolverService,
    ) {
    
  }
  init(callback?) {
    var obj: any = {};
    obj.headerJson = this.appService.getAppHeader();
    this._appUri = this.appService.getApplication();
    callback(obj);
  }
  setMenuDefinition(menuDef){
    this.menuDef = menuDef;
  }
  setRouteDefinition(routeDef){
    this.routeDef = routeDef;
  }
  setCrudList(crudList){
    this.crudList = crudList;
  }
  setDefaultApplication(app){
    this.defaultApplication = app;
  }
  // getMenu(callback){
  //  return this.baseService.getMenu(JSON.parse(JSON.stringify(this.menuDef)),callback);
  // }

 

  getRoutes(application){
    var childRoutes:Routes = this.commonResolverService.getApplicationRoute(this.menuDef); //automatic crud route generated from menu
    //TODO: define static routes here
    childRoutes.push({
        path: '',
        redirectTo : this.defaultApplication,//TODO: default application here (may be we can get it in get tiles request)
        pathMatch: 'prefix',
    });
    
    console.log("childRoutes==>",childRoutes);
    
    var crudMenuDef = this.convertCrudToMenuDef(application);
    if(crudMenuDef){
      var crudRoutes:Routes = this.commonResolverService.getApplicationRoute(crudMenuDef);
      childRoutes = childRoutes.concat(crudRoutes);
    }
    
    childRoutes = childRoutes.concat(this.routeDef);
    return childRoutes;
  }

  convertCrudToMenuDef(application){
    if(this.crudList.length){
      var menuDef:any =
        {
              name: application,
              data: {
                  nav_url: "nav_"+application
              },
              children: []
        }
      for (let index = 0; index < this.crudList.length; index++) {
        var singleCrud = this.crudList[index];
        var singleMenu = {
            "name": singleCrud.name,
            "resource":  singleCrud.name,
            "url": (singleCrud.url != undefined)?singleCrud.url:singleCrud.name,
            "auto_crud": true,
            check_permission:false
        };
        menuDef.children.push(singleMenu);
      }
      return [menuDef];
    }else{
      return false;
    }
  }
 
  filterSidebar(sidebarJson) {
    return sidebarJson = sidebarJson.filter(function (x) {
      if (x.children) {
        x.children = x.children.filter(function (y) {
          return y.showMenu == undefined || y.showMenu
        });
        return x;
      } else {
        return x.showMenu == undefined || x.showMenu
      }
    });
  }
} 
